import { webTitle } from "@/config/index";
import storage from "@/utils/storage";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  /**网页不能回退-1*/
  scrollBehavior: () => {
    history.pushState(history.state, "", document.URL);
  },

  routes: [
    /**登录和错误页面*/
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/login/LoginPage.vue"),
      //component: () => import("@/views/sys/login/LoginPage.vue"),
      meta: { title: "管理系统" },
    },
    {
      name: "error-page",
      path: "/error-page",
      component: () => import("@/views/ErrorPage.vue"),
      meta: { title: webTitle + "/ 页面出错了" },
    },
    {
      name: "not-page",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/NotPage.vue"),
      meta: { title: webTitle + "/ 页面不存在" },
    },

   

    /**系统*/
    {
      name: "sys-login-page",
      path: "/sys-login-page",
      component: () => import("@/views/sys/login/LoginPage.vue"),
      meta: { title: webTitle + "/ 系统管理" },
    },
    {
      name: "sys-index-page",
      path: "/sys-index-page",
      component: () => import("@/views/sys/index/IndexPage.vue"),
      children: [
        {
          name: "sys-index-user-view",
          path: "/sys-index-user-view",
          component: () => import("@/views/sys/user/UserView.vue"),
          meta: { title: webTitle + "/ 系统管理 / 基本信息" },
        },
        {
          name: "sys-index-member-list",
          path: "/sys-index-member-list",
          component: () => import("@/views/sys/member/MemberList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 客户信息" },
        },
        {
          name: "sys-index-place-list",
          path: "/sys-index-place-list",
          component: () => import("@/views/sys/place/PlaceList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 站点信息" },
        },
        {
          name: "sys-index-bind-list",
          path: "/sys-index-bind-list",
          component: () => import("@/views/sys/bind/BindList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 站点绑定" },
        },
        {
          name: "sys-index-template-set-list",
          path: "/sys-index-template-set-list",
          component: () => import("@/views/sys/templateset/TemplateSetList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 模版设置" },
        },        
        {
          name: "sys-index-member-user-list",
          path: "/sys-index-member-user-list",
          component: () => import("@/views/sys/memberuser/MemberUserList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 客户用户" },
        },
         {
          name: "sys-index-set-text-list",
          path: "/sys-index-set-text-list",
          component: () => import("@/views/sys/text/SetTextList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 设置短信" },
        },
         {
          name: "sys-index-fee-recharge-list",
          path: "/sys-index-fee-recharge-list",
          component: () => import("@/views/sys/recharge/FeeRechargeList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 费用充值" },
        },
        {
          name: "sys-index-node-list",
          path: "/sys-index-node-list",
          component: () => import("@/views/sys/node/NodeList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 栏目信息" },
        },
        {
          name: "sys-index-log-login-list",
          path: "/sys-index-log-login-list",
          component: () => import("@/views/sys/log/LogLoginList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 登录日志" },
        },
        {
          name: "sys-index-log-change-list",
          path: "/sys-index-log-change-list",
          component: () => import("@/views/sys/log/LogChangeList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 操作日志" },
        },
        {
          name: "sys-index-log-error-list",
          path: "/sys-index-log-error-list",
          component: () => import("@/views/sys/log/LogErrorList.vue"),
          meta: { title: webTitle + "/ 系统管理 / 操作错误" },
        },         
        {
          name: "sys-index-test",
          path: "/sys-index-test",
          component: () => import("@/views/sys/index/TestPage.vue"),
          meta: { title: webTitle + "/ 系统管理 / 测试页面" },
        },
      ],
      meta: { title: webTitle + "/ 管理员" },
    },

    /**客户后台*/
    {
      name: "/admin-index-page",
      path: "/admin-index-page",
      component: () => import("@/views/admin/index/IndexPage.vue"),
      children: [
        {
          name: "admin-index-member-view",
          path: "/admin-index-member-view",
          component: () => import("@/views/admin/member/MemberView.vue"),
          meta: { title: webTitle + "/ 管理员 / 客户信息" },
        },
        {
          name: "admin-index-member-password",
          path: "/admin-index-member-password",
          component: () => import("@/views/admin/member/MemberPassword.vue"),
          meta: { title: webTitle + "/ 管理员 / 修改密码" },
        },
        {
          name: "admin-index-user-list",
          path: "/admin-index-user-list",
          component: () => import("@/views/admin/user/UserList.vue"),
          meta: { title: webTitle + "/ 管理员 / 用户信息" },
        },
        {
          name: "admin-index-view-consignment-list",
          path: "/admin-index-view-consignment-list",
          component: () => import("@/views/admin/viewconsignment/ViewConsignmentList.vue"),
          meta: { title: webTitle + "/ 管理员 / 查看托单" },
        },
        {
          name: "admin-index-node-list",
          path: "/admin-index-node-list",
          component: () => import("@/views/admin/node/NodeList.vue"),
          meta: { title: webTitle + "/ 管理员 / 菜单权限" },
        },
        {
          name: "admin-index-role-list",
          path: "/admin-index-role-list",
          component: () => import("@/views/admin/role/RoleList.vue"),
          meta: { title: webTitle + "/ 管理员 / 角色信息" },
        },
        {
          name: "admin-index-place-bind-list",
          path: "/admin-index-place-bind-list",
          component: () => import("@/views/admin/place/PlaceBindList.vue"),
          meta: { title: webTitle + "/ 管理员 / 站点绑定" },
        },
        {
          name: "admin-index-log-login-list",
          path: "/admin-index-log-login-list",
          component: () => import("@/views/admin/log/LogLoginList.vue"),
          meta: { title: webTitle + "/ 管理员 / 登录日志" },
        },
        {
          name: "admin-index-log-change-list",
          path: "/admin-index-log-change-list",
          component: () => import("@/views/admin/log/LogChangeList.vue"),
          meta: { title: webTitle + "/ 管理员 / 操作日志" },
        },
      ],
      meta: { title: webTitle + "/ 管理员" },
    },

    /**工作*/
    {
      name: "index-page",
      path: "/index-page",
      component: () => import("@/views/IndexPage.vue"),
      children: [
        /**工作台*/
        {
          name: "home-page",
          path: "/home-page",
          component: () => import("@/views/HomePage.vue"),
          meta: { title: webTitle + "/ 首页" },
        },

        /**移动页面菜单*/
        {
          name: "mobile-side-bar",
          path: "/mobile-side-bar",
          component: () => import("@/components/MobileSideBar.vue"),
          meta: { title: webTitle + "/ 菜单" },
        },       

        /**参数管理-联系信息 */
        {
          name: "param-index-contact-index",
          path: "/param-index-contact-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 参数管理 / 联系信息" },

          children: [
            {
              name: "param-index-contact-index-send-list",
              path: "/param-index-contact-index-send-list/:id",
              component: () => import("@/views/work/param/contact/send/SendList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 联系信息 / 发货方",
                activeMenu: "/param-index-contact-index",
               },
            },
            {
              name: "param-index-contact-index-receive-list",
              path: "/param-index-contact-index-receive-list/:id",
              component: () => import("@/views/work/param/contact/receive/ReceiveList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 收货方",
                activeMenu: "/param-index-contact-index",
               },
            },
              {
              name: "param-index-contact-index-send-receive-list",
              path: "/param-index-contact-index-send-receive-list/:id",
              component: () => import("@/views/work/param/contact/sendreceive/SendReceiveList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 收货方",
                activeMenu: "/param-index-contact-index",
               },
            },
            {
              name: "param-index-contact-index-vehicle-list",
              path: "/param-index-contact-index-vehicle-list/:id",
              component: () => import("@/views/work/param/contact/vehicle/VehicleList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 运输车辆",
                activeMenu: "/param-index-contact-index",
               },
            },
            {
              name: "param-index-contact-index-carrier-list",
              path: "/param-index-contact-index-carrier-list/:id",
              component: () => import("@/views/work/param/contact/carrier/CarrierList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 承运商",
                activeMenu: "/param-index-contact-index",
               },
            },
            {
              name: "param-index-contact-index-sign-in-list",
              path: "/param-index-contact-index-sign-in-list/:id",
              component: () => import("@/views/work/param/contact/signin/SignInList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 签收人",
                activeMenu: "/param-index-contact-index",
               },
            },  
             {
              name: "param-index-contact-index-pack-list",
              path: "/param-index-contact-index-pack-list/:id",
              component: () => import("@/views/work/param/contact/pack/PackList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 包装",
                activeMenu: "/param-index-contact-index",
               },
            },  
              {
              name: "param-index-contact-index-cost-list",
              path: "/param-index-contact-index-cost-list/:id",
              component: () => import("@/views/work/param/contact/cost/CostList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 联系信息 / 应付报价",
                activeMenu: "/param-index-contact-index",
               },
            },  
          ],
        },
        /**参数管理-参数分类 */
        {
          name: "param-index-category-index",
          path: "/param-index-category-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 参数管理 / 参数分类" },

          children: [
            {
              name: "param-index-category-index-info-list",
              path: "/param-index-category-index-info-list/:id",
              component: () => import("@/views/work/param/category/info/InfoList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 参数分类 / 参数分类",
                activeMenu: "/param-index-category-index",
               },
            },
            {
              name: "param-index-category-index-income-expenses-class-list",
              path: "/param-index-category-index-income-expenses-class-list/:id",
              component: () => import("@/views/work/param/category/incomeexpenses/IncomeExpensesClassList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 参数分类 / 费用分类",
                activeMenu: "/param-index-category-index",
               },
            },            
          ],
        },

        {
          name: "param-index-set-index",
          path: "/param-index-set-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 参数管理 / 模版设置" },

          children: [           
            {
              name: "param-index-set-index-control-set-info",
              path: "/param-index-set-index-control-set-info/:id",
              component: () => import("@/views/work/param/set/controlset/ControlSetInfo.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 模版设置 / 录入模版设置 ",
                activeMenu: "/param-index-set-index",
              },
            },
            {
              name: "param-index-set-index-template-set-info",
              path: "/param-index-set-index-template-set-info/:id",
              component: () =>
                import("@/views/work/param/set/templateset/TemplateSetList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 模版设置 / 打印模版设置 ",
                activeMenu: "/param-index-set-index",
              },
            },
            {
              name: "param-index-set-index-template-use-info",
              path: "/param-index-set-index-template-use-info/:id",
              component: () =>
                import("@/views/work/param/set/templateuse/TemplateUseList.vue"),
              meta: {
                title: webTitle + " / 参数管理 / 模版设置 / 打印模版使用 ",
                activeMenu: "/param-index-set-index",
              },
            },
          ],
        },
        {
          name: "param-index-number-list",
          path: "/param-index-number-list/:id",
          component: () =>import("@/views/work/param/number/NumberList.vue"),
          meta: { title: webTitle + "/ 参数管理 / 单号设置" },
        },

        /**公共查询-开始*/
        {
          name: "business-index-query-index",
          path: "/business-index-query-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 业务管理 / 公共查询" },

          children: [           
            {
              name: "business-index-query-index-consignment-all-list",
              path: "/business-index-query-index-consignment-all-list/:id",
              component: () => import("@/views/work/business/query/consignmentall/ConsignmentAllList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 托单信息 ",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-consignment-start-list",
              path: "/business-index-query-index-consignment-start-list/:id",
              component: () => import("@/views/work/business/query/consignmentstart/ConsignmentStartList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 发站托单 ",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-consignment-arrive-list",
              path: "/business-index-query-index-consignment-arrive-list/:id",
              component: () => import("@/views/work/business/query/consignmentarrive/ConsignmentArriveList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 到站托单 ",
                activeMenu: "/business-index-query-index",
              },
            },            
            {
              name: "business-index-query-index-long-track-list",
              path: "/business-index-query-index-long-track-list/:id",
              component: () => import("@/views/work/business/query/longtrack/LongTrackList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 干线跟踪",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-long-correlate-fee-list",
              path: "/business-index-query-index-long-correlate-fee-list/:id",
              component: () => import("@/views/work/business/query/longcorrelate/LongCorrelateFeeList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 干线往来费用 ",
                activeMenu: "/business-index-query-index",
              },
            },   
            {
              name: "business-index-query-index-not-operate-all-list",
              path: "/business-index-query-index-not-operate-all-list/:id",
              component: () => import("@/views/work/business/query/notall/NotOperateAll.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 未操作 ",
                activeMenu: "/business-index-query-index",
              },
            }, 
            {
              name: "business-index-query-index-not-operate-start-list",
              path: "/business-index-query-index-not-operate-start-list/:id",
              component: () => import("@/views/work/business/query/notstart/NotOperateStart.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 发站未操作 ",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-not-operate-arrive-list",
              path: "/business-index-query-index-not-operate-arrive-list/:id",
              component: () => import("@/views/work/business/query/notarrive/NotOperateArrive.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 到站未操作 ",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-send-text-long-prepare-list",
              path: "/business-index-query-index-send-text-long-prepare-list/:id",
              component: () => import("@/views/work/business/query/sendtext/SendTextLongPrepareList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 发送短信 ",
                activeMenu: "/business-index-query-index",
              },
            },
            {
              name: "business-index-query-index-send-text-list",
              path: "/business-index-query-index-send-text-list/:id",
              component: () => import("@/views/work/business/query/sendtext/SendTextList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 短信记录 ",
                activeMenu: "/business-index-query-index",
              },
            },
            
             {
              name: "business-index-query-index-consignment-track-list",
              path: "/business-index-query-index-consignment-track-list/:id",
              component: () => import("@/views/work/business/query/consignmenttrack/ConsignmentTrackList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 托单跟踪 ",
                activeMenu: "/business-index-query-index",
              },
            },
          ],
        },
        /**公共查询-结束 */


        /**托单管理-开始*/
        {
          name: "business-index-consignment-index",
          path: "/business-index-consignment-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 业务管理 / 托单管理" },

          children: [
            {
              name: "business-index-consignment-index-consignment-tips",
              path: "/business-index-consignment-index/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentTips.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 概况",
                activeMenu: "/business-index-consignment-index",
              },
            },
            {
              name: "business-index-consignment-index-consignment-add1",
              path: "/business-index-consignment-index-consignment-add1/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentAdd1.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 新增托单",
                activeMenu: "/business-index-consignment-index",
              },
            },
            {
              name: "business-index-consignment-index-consignment-stock-list",
              path: "/business-index-consignment-index-consignment-stock-list/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentStockList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 库存托单",
                activeMenu: "/business-index-consignment-index",
              },
            },
            {
              name: "business-index-consignment-index-consignment-update-list",
              path: "/business-index-consignment-index-consignment-update-list/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 修改托单",
                activeMenu: "/business-index-consignment-index",
              },
            },


            /**托单录入2 */
              {
              name: "business-index-consignment-index-consignment-add2",
              path: "/business-index-consignment-index-consignment-add2/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentAdd2.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 新增托单",
                activeMenu: "/business-index-consignment-index",
              },
            },
            {
              name: "business-index-consignment-index-consignment-stock-list2",
              path: "/business-index-consignment-index-consignment-stock-list2/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentStockList2.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 库存托单",
                activeMenu: "/business-index-consignment-index",
              },
            },
            {
              name: "business-index-consignment-index-consignment-update-list2",
              path: "/business-index-consignment-index-consignment-update-list2/:id",
              component: () =>import("@/views/work/business/consignment/ConsignmentUpdateList2.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 修改托单",
                activeMenu: "/business-index-consignment-index",
              },
            },

             {
              name: "business-index-consignment-index-consignment-prepare-list",
              path: "/business-index-consignment-index-consignment-prepare-list/:id",
              component: () =>import("@/views/work/business/template/ConsignmentPrepareList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 模版",
                activeMenu: "/business-index-consignment-index",
              },
            },
             {
              name: "business-index-consignment-index-consignment-template-cost-update-list",
              path: "/business-index-consignment-index-consignment-template-cost-update-list/:id",
              component: () =>import("@/views/work/business/template/ConsignmentTemplateCostUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 托单管理 / 预计揽收",
                activeMenu: "/business-index-consignment-index",
              },
            },
          ],
          
        },
        /**托单管理-结束 */

          /**货代管理-开始*/
          {
            name: "business-index-tripartite-index",
            path: "/business-index-tripartite-index/:id",
            component: () => import("@/components/BaseSubNode.vue"),
            meta: { title: webTitle + "/ 业务管理 / 货代管理" },
  
            children: [
              {
                name: "business-index-tripartite-index-tripartite-tips",
                path: "/business-index-tripartite-index/:id",
                component: () =>
                  import("@/views/work/business/tripartite/TripartiteTips.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 货代管理 / 概况",
                  activeMenu: "/business-index-tripartite-index",
                },
              },
              {
                name: "business-index-tripartite-index-tripartite-prepare-list",
                path: "/business-index-tripartite-index-tripartite-prepare-list/:id",
                component: () =>
                  import("@/views/work/business/tripartite/TripartitePrepareList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 货代管理 / 货代发货",
                  activeMenu: "/business-index-tripartite-index",
                },
              },
              {
                name: "business-index-tripartite-index-tripartite-update-list",
                path: "/business-index-tripartite-index-tripartite-update-list/:id",
                component: () =>
                  import("@/views/work/business/tripartite/TripartiteUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 货代管理 / 货代清单",
                  activeMenu: "/business-index-tripartite-index",
                },
              },

               {
                name: "business-index-tripartite-index-tripartite-track-list",
                path: "/business-index-tripartite-index-tripartite-track-list/:id",
                component: () =>
                  import("@/views/work/business/tripartite/TripartiteTrackList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 货代管理 / 货代跟踪",
                  activeMenu: "/business-index-tripartite-index",
                },
              },
            ],
          },
          /**货代管理-结束 */

        /**干线运输-开始*/
        {
          name: "business-index-long-index",
          path: "/business-index-long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 业务管理 / 干线运输" },

          children: [
            {
              name: "business-index-long-index-long-tips",
              path: "/business-index-long-index/:id",
              component: () =>
                import("@/views/work/business/long/LongTips.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 干线运输 / 概况",
                activeMenu: "/business-index-long-index",
              },
            },
            {
              name: "business-index-long-index-long-update-list",
              path: "/business-index-long-index-long-update-list/:id",
              component: () =>
                import("@/views/work/business/long/LongUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 干线运输 / 干线清单",
                activeMenu: "/business-index-long-index",
              },
            },
            {
              name: "business-index-long-index-long-start-track-list",
              path: "/business-index-long-index-long-start-track-list/:id",
              component: () =>
                import("@/views/work/business/long/LongStartTrackList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 干线运输 / 干线跟踪",
                activeMenu: "/business-index-long-index",
              },
            },
          ],
        },
        /**干线运输-结束 */

        /**短途运输-开始*/
        {
            name: "business-index-short-index",
            path: "/business-index-short-index/:id",
            component: () => import("@/components/BaseSubNode.vue"),
            meta: { title: webTitle + "/ 业务管理 / 短途运输" },
  
            children: [
              {
                name: "business-index-short-index-short-tips",
                path: "/business-index-short-index/:id",
                component: () =>
                  import("@/views/work/business/short/ShortTips.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 短途运输 / 概况",
                  activeMenu: "/business-index-short-index",
                },
              },  
              {
                name: "business-index-short-index-single-send-prepare-list",
                path: "/business-index-short-index-single-send-prepare-list/:id",
                component: () =>
                  import("@/views/work/business/short/SingleSendPrepareList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 短途运输 / 单票送货",
                  activeMenu: "/business-index-short-index",
                },
              },  
              {
                name: "business-index-short-index-single-pick-up-prepare-list",
                path: "/business-index-short-index-single-pick-up-prepare-list/:id",
                component: () =>
                  import("@/views/work/business/short/SinglePickUpPrepareList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 短途运输 / 单票提货",
                  activeMenu: "/business-index-short-index",
                },
              },  
              {
                name: "business-index-short-index-short-update-list",
                path: "/business-index-short-index-short-update-list/:id",
                component: () =>
                  import("@/views/work/business/short/ShortUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 短途运输 / 短途清单",
                  activeMenu: "/business-index-short-index",
                },
              },
              {
                name: "business-index-short-index-short-detail-list",
                path: "/business-index-short-index-short-detail-list/:id",
                component: () =>
                  import("@/views/work/business/short/ShortDetailList.vue"),
                meta: {
                  title: webTitle + " / 业务管理 / 短途运输 / 短途明细",
                  activeMenu: "/business-index-short-index",
                },
              },
               {
                name: "business-index-short-index-single-pick-up-prepare-list2" ,
                path: "/business-index-short-index-single-pick-up-prepare-list2/:id",
                component: () =>
                  import("@/views/work/business/short/SinglePickUpPrepareList2.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 短途运输 / 单票提货(送)",
                  activeMenu: "/business-index-short-index",
                },
              },  
            ],
        },
        /**短途运输-结束 */

         /**中转管理-开始*/
        {
          name: "business-index-transfer-index",
          path: "/business-index-transfer-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 业务管理 / 中转管理" },

          children: [
            {
              name: "business-index-transfer-index-transfer-tips",
              path: "/business-index-transfer-index/:id",
              component: () =>
                import("@/views/work/business/transfer/TransferTips.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 中转管理 / 概况",
                activeMenu: "/business-index-transfer-index",
              },
            },
            {
              name: "business-index-transfer-index-transfer-prepare-list",
              path: "/business-index-transfer-index-transfer-prepare-list/:id",
              component: () =>
                import("@/views/work/business/transfer/TransferPrepareList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 中转管理 / 中转发货",
                activeMenu: "/business-index-transfer-index",
              },
            },
            {
              name: "business-index-transfer-index-transfer-update-list",
              path: "/business-index-transfer-index-transfer-update-list/:id",
              component: () =>
                import("@/views/work/business/transfer/TransferUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 中转管理 / 中转清单",
                activeMenu: "/business-index-tranfer-index",
              },
            },
          ],
        },
        /**中转管理-结束 */

        /**签收管理-开始*/
        {
            name: "business-index-sign-in-index",
            path: "/business-index-sign-in-index/:id",
            component: () => import("@/components/BaseSubNode.vue"),
            meta: { title: webTitle + "/ 业务管理 / 签收管理" },
  
            children: [
              {
                name: "business-index-sign-in-index-sign-in-tips",
                path: "/business-index-sign-in-index/:id",
                component: () =>
                  import("@/views/work/business/signin/SignInTips.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 签收管理 / 概况",
                  activeMenu: "/business-index-sign-in-index",
                },
              },
              {
                name: "business-index-sign-in-index-sign-in-prepare-start-list",
                path: "/business-index-sign-in-index-sign-in-prepare-start-list/:id",
                component: () =>
                  import("@/views/work/business/signin/SignInPrepareStartList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 签收管理 / 发站签收",
                  activeMenu: "/business-index-sign-in-index",
                },
              },
              {
                name: "business-index-sign-in-index-sign-in-prepare-arrive-list",
                path: "/business-index-sign-in-index-sign-in-prepare-arrive-list/:id",
                component: () =>
                  import("@/views/work/business/signin/SignInPrepareArriveList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 签收管理 / 到站签收",
                  activeMenu: "/business-index-sign-in-index",
                },
              },
              {
                name: "business-index-sign-in-index-sign-in-prepare-arrive-check-list",
                path: "/business-index-sign-in-index-sign-in-prepare-arrive-check-list/:id",
                component: () =>
                  import("@/views/work/business/signin/SignInPrepareArriveCheckList.vue"),
                meta: {
                  title: webTitle + " / 业务管理 / 签收管理 / 到站签收结账",
                  activeMenu: "/business-index-sign-in-index",
                },
              },
              {
                name: "business-index-sign-in-index-sign-in-update-list",
                path: "/business-index-sign-in-index-sign-in-update-list/:id",
                component: () =>
                  import("@/views/work/business/signin/SignInUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 签收管理 / 签收清单",
                  activeMenu: "/business-index-sign-in-index",
                },
              },
            ],
        },
        /**签收管理-结束 */


         /**回执管理-开始*/
        {
            name: "business-index-receipt-index",
            path: "/business-index-receipt-index/:id",
            component: () => import("@/components/BaseSubNode.vue"),
            meta: { title: webTitle + "/ 业务管理 / 回执管理" },
  
            children: [
              {
                name: "business-index-receipt-index-receipt-tips",
                path: "/business-index-receipt-index-receipt-tips/:id",
                component: () =>import("@/views/work/business/receipt/ReceiptTips.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 概况",
                  activeMenu: "/business-index-receipt-index",
                },
              },
              {
                name: "business-index-receipt-index-post-update-list",
                path: "/business-index-receipt-index-post-update-list/:id",
                component: () =>
                  import("@/views/work/business/receipt/post/PostUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 邮寄回执",
                  activeMenu: "/business-index-receipt-index",
                },
              },
              {
                name: "business-index-receipt-index-post-accept-update-list",
                path: "/business-index-receipt-index-post-accept-update-list/:id", 
                component: () =>
                  import("@/views/work/business/receipt/postaccept/PostAcceptUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 邮寄接收",
                  activeMenu: "/business-index-receipt-index",
                },
              },
              {
                name: "business-index-receipt-index-accept-prepare-list",
                path: "/business-index-receipt-index-accept-prepare-list/:id",
                component: () =>
                  import("@/views/work/business/receipt/accept/AcceptPrepareList.vue"),
                meta: {
                  title: webTitle + " / 业务管理 / 回执管理 / 发站接收回执",
                  activeMenu: "/business-index-receipt-index",
                },
              },
              {
                name: "business-index-receipt-index-accept-update-list",
                path: "/business-index-receipt-index-accept-update-list/:id",
                component: () =>
                  import("@/views/work/business/receipt/accept/AcceptUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 接收回执清单",
                  activeMenu: "/business-index-receipt-index",
                },
              },
               {
                name: "business-index-receipt-index-taken-update-list",
                path: "/business-index-receipt-index-taken-update-list/:id",
                component: () =>
                  import("@/views/work/business/receipt/taken/TakenUpdateList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 取走回执清单",
                  activeMenu: "/business-index-receipt-index",
                },
              },
               {
                name: "business-index-receipt-index-receipt-list",
                path: "/business-index-receipt-index-receipt-list/:id",
                component: () =>
                  import("@/views/work/business/receipt/ReceiptList.vue"),
                meta: {
                  title: webTitle + "/ 业务管理 / 回执管理 / 回执查询",
                  activeMenu: "/business-index-receipt-index",
                },
              },
            ],
        },
        /**回执管理-结束 */

        /**其他费用-开始*/
        {
          name: "business-index-other-charges-index",
          path: "/business-index-other-charges-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 业务管理 / 其他费用" },

          children: [
            // {
            //   name: "business-index-sign-in-index-sign-in-tips",
            //   path: "/business-index-sign-in-index/:id",
            //   component: () =>
            //     import("@/views/work/business/signin/SignInTips.vue"),
            //   meta: {
            //     title: webTitle + "/ 业务管理 / 签收管理 / 概况",
            //     activeMenu: "/business-index-sign-in-index",
            //   },
            // },
            {
              name: "business-index-other-charges-index-consignment-other-charges-prepare-list",
              path: "/business-index-other-charges-index-consignment-other-charges-prepare-list/:id",
              component: () =>
                import("@/views/work/business/other/ConsignmentOtherChargesPrepareList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 其他费用 / 新增托单费用",
                activeMenu: "/business-index-other-charges-index",
              },
            },
            {
              name: "business-index-other-charges-index-consignment-other-charges-update-list",
              path: "/business-index-other-charges-index-consignment-other-charges-update-list/:id",
              component: () =>
                import("@/views/work/business/other/ConsignmentOtherChargesUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 其他费用 / 托单费用明细",
                activeMenu: "/business-index-other-charges-index",
              },
            },
            {
              name: "business-index-other-charges-index-long-other-charges-prepare-list",
              path: "/business-index-other-charges-index-long-other-charges-prepare-list/:id",
              component: () =>
                import("@/views/work/business/other/LongOtherChargesPrepareList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 其他费用 / 新增干线费用",
                activeMenu: "/business-index-other-charges-index",
              },
            },
            {
              name: "business-index-other-charges-index-long-other-charges-update-list",
              path: "/business-index-other-charges-index-long-other-charges-update-list/:id",
              component: () =>
                import("@/views/work/business/other/LongOtherChargesUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 其他费用 / 干线费用明细",
                activeMenu: "/business-index-other-charges-index",
              },
            },
          ],
      },
      /**其他费用-结束 */

       /**到站分配-开始*/
       {
        name: "business-index-allot-index",
        path: "/business-index-allot-index/:id",
        component: () => import("@/components/BaseSubNode.vue"),
        meta: { title: webTitle + "/ 业务管理 / 到站分配" },

        children: [
          // {
          //   name: "business-index-sign-in-index-sign-in-tips",
          //   path: "/business-index-sign-in-index/:id",
          //   component: () =>
          //     import("@/views/work/business/signin/SignInTips.vue"),
          //   meta: {
          //     title: webTitle + "/ 业务管理 / 签收管理 / 概况",
          //     activeMenu: "/business-index-sign-in-index",
          //   },
          // },
          {
            name: "business-index-allot-index-allot-consignment-list",
            path: "/business-index-allot-index-allot-consignment-list/:id",
            component: () =>
              import("@/views/work/business/allot/AllotConsignmentList.vue"),
            meta: {
              title: webTitle + "/ 业务管理 / 到站分配 / 托单查询",
              activeMenu: "/business-index-allot-index",
            },
          },
          {
            name: "business-index-allot-index-allot-prepare-list",
            path: "/business-index-allot-index-allot-prepare-list/:id",
            component: () =>
              import("@/views/work/business/allot/AllotPrepareList.vue"),
            meta: {
              title: webTitle + "/ 业务管理 / 到站分配 / 托单分配",
              activeMenu: "/business-index-allot-index",
            },
          },          
          {
            name: "business-index-allot-index-share-allot-update-list",
            path: "/business-index-allot-index-share-allot-update-list/:id",
            component: () =>
              import("@/views/work/business/allot/AllotUpdateList.vue"),
            meta: {
              title: webTitle + "/ 业务管理 / 到站分配 / 分配明细",
              activeMenu: "/business-index-allot-index",
            },
          },
        ],
    },
    /**到站分配-结束 */


     /**其他收支-开始*/
    {
      name: "cost-index-other-index",
      path: "/cost-index-other-index/:id",
      component: () => import("@/components/BaseSubNode.vue"),
      meta: { title: webTitle + "/ 其他费用 / 其他收支" },

      children: [
        {
          name: "cost-index-other-index-other-income-expenses-add",
          path: "/cost-index-other-index-other-income-expenses-add/:id",
          component: () =>import("@/views/work/cost/other/OtherIncomeExpensesAdd.vue"),
          meta: {
            title: webTitle + "/ 其他费用 / 其他收支 / 新增",
            activeMenu: "/cost-index-other-index",
          },
        },
        {
          name: "cost-index-other-index-other-income-expenses-update-list",
          path: "/cost-index-other-index-other-income-expenses-update-list/:id",
          component: () =>import("@/views/work/cost/other/OtherIncomeExpensesUpdateList.vue"),
          meta: {
            title: webTitle + "/ 业务管理 / 其他收支 / 清单",
            activeMenu: "/cost-index-other-index",
          },
        }, 
      ],
    },
    /**其他收支-结束 */

     /**员工工资-开始*/
     {
      name: "cost-index-salary-index",
      path: "/cost-index-salary-index/:id",
      component: () => import("@/components/BaseSubNode.vue"),
      meta: { title: webTitle + "/ 其他费用 / 员工工资" },

      children: [
        {
          name: "cost-index-salary-index-staff-update-list",
          path: "/cost-index-salary-index-staff-update-list/:id",
          component: () =>import("@/views/work/cost/salary/StaffUpdateList.vue"),
          meta: {
            title: webTitle + "/ 其他费用 / 员工工资 / 员工信息",
            activeMenu: "/cost-index-salary-index",
          },
        },
        {
          name: "cost-index-salary-index-salary-update-list",
          path: "/cost-index-salary-index-salary-update-list/:id", 
          component: () =>import("@/views/work/cost/salary/SalaryUpdateList.vue"),
          meta: {
            title: webTitle + "/ 业务管理 / 员工工资 / 工资清单",
            activeMenu: "/cost-index-salary-index",
          },
        }, 
      ],
    },
    /**员工工资-结束 */      

        /**自有车辆-开始*/
        {
          name: "cost-index-owning-car-index",
          path: "/cost-index-owning-car-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 其他费用 / 自有车辆" },

          children: [
            {
              name: "cost-index-owning-car-index-owning-car-add",
              path: "/cost-index-owning-car-index-owning-car-add/:id",
              component: () => import("@/views/work/cost/owningcar/OwningCarAdd.vue"),
              meta: {
                title: webTitle + "/ 其他费用 / 自有车辆 / 新增",
                activeMenu: "/cost-index-owning-car-index",
              },
            },
            {
              name: "cost-index-owning-car-index-owning-car-update-list",
              path: "/cost-index-owning-car-index-owning-car-update-list/:id",
              component: () => import("@/views/work/cost/owningcar/OwningCarUpdateList.vue"),
              meta: {
                title: webTitle + "/ 业务管理 / 自有车辆 / 清单",
                activeMenu: "/cost-index-owning-car-index",
              },
            },
          ],
        },
        /**自有车辆-结束 */

         /**期初余额-开始*/
        {
          name: "cost-index-balance-index-opening-balance-update-list",
          path: "/cost-index-balance-index-opening-balance-update-list/:id",
          component: () => import("@/views/work/cost/balance/OpeningBalanceUpdateList.vue"),
          meta: { title: webTitle + "/ 其他费用 / 期初余额" },
        },
        /**期初余额-结束*/
      
        /**发货结账-开始*/
        {
          name: "check-index-consignment-index",
          path: "/check-index-consignment-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 发货结账" },

          children: [
            {
              name: "check-index-consignment-index-consignment-tips",
              path: "/check-index-consignment-index/:id",
              component: () =>
                import("@/views/work/check/consignment/ConsignmentTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 概况",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-shortcut-check-prepare-list",
              path: "/check-index-consignment-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignment/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 快捷结账",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-shortcut-check-update-list",
              path: "/check-index-consignment-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignment/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 快结清单",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-bill-note-update-list",
              path: "/check-index-consignment-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/consignment/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 对账单",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-bill-check-prepare-list",
              path: "/check-index-consignment-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignment/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 对账单结账",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-bill-check-update-list",
              path: "/check-index-consignment-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignment/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 结账清单",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-no-reconcile-count-list",
              path: "/check-index-consignment-index-no-reconcile-count-list/:id",
              component: () =>
                import("@/views/work/check/consignment/count/NoReconcileCountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 未对账",
                activeMenu: "/check-index-consignment-index",
              },
            },
            {
              name: "check-index-consignment-index-count-list",
              path: "/check-index-consignment-index-count-list/:id",
              component: () =>
                import("@/views/work/check/consignment/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 发货结账 / 统计",
                activeMenu: "/check-index-consignment-index",
              },
            },
          ],
        },
        /**发货结账-结束 */

        /**干线结账-开始*/
        {
          name: "check-index-long-index",
          path: "/check-index-long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 干线结账" },

          children: [
            {
              name: "check-index-long-index-long-tips",
              path: "/check-index-long-index/:id",
              component: () =>
                import("@/views/work/check/long/LongTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 概况",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-shortcut-check-prepare-list",
              path: "/check-index-long-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/long/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 快捷结账",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-shortcut-check-update-list",
              path: "/check-index-long-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/long/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 快结清单",
                activeMenu: "/check-index-long-index",
              },
            },
{
              name: "check-index-long-index-bill-note-update-list",
              path: "/check-index-long-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/long/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 对账单",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-bill-check-prepare-list",
              path: "/check-index-long-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/long/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 对账单结账",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-bill-check-update-list",
              path: "/check-index-long-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/long/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 结账清单",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-no-reconcile-count-list",
              path: "/check-index-long-index-no-reconcile-count-list/:id",
              component: () =>
                import("@/views/work/check/long/count/NoReconcileCountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 未对账",
                activeMenu: "/check-index-long-index",
              },
            },
            {
              name: "check-index-long-index-count-list",
              path: "/check-index-long-index-count-list/:id",
              component: () =>
                import("@/views/work/check/long/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线结账 / 统计",
                activeMenu: "/check-index-long-index",
              },
            },
          ],
        },
        /**干线结账-结束 */

        /**短途结账-开始*/
        {
          name: "check-index-short-index",
          path: "/check-index-short-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 短途结账" },

          children: [
            {
              name: "check-index-short-index-short-tips",
              path: "/check-index-short-index/:id",
              component: () =>
                import("@/views/work/check/short/ShortTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 概况",
                activeMenu: "/check-index-short-index",
              },
            },
            {
              name: "check-index-short-index-shortcut-check-prepare-list",
              path: "/check-index-short-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/short/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 快捷结账",
                activeMenu: "/check-index-short-index",
              },
            },
            {
              name: "check-index-short-index-shortcut-check-update-list",
              path: "/check-index-short-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/short/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 快结清单",
                activeMenu: "/check-index-short-index",
              },
            },

             {
              name: "check-index-short-index-bill-note-update-list",
              path: "/check-index-short-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/short/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 对账单",
                activeMenu: "/check-index-short-index",
              },
            },
            {
              name: "check-index-short-index-bill-check-prepare-list",
              path: "/check-index-short-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/short/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 对账单结账",
                activeMenu: "/check-index-short-index",
              },
            },
            {
              name: "check-index-short-index-bill-check-update-list",
              path: "/check-index-short-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/short/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 结账清单",
                activeMenu: "/check-index-short-index",
              },
            },

            {
              name: "check-index-short-index-no-reconcile-count-list",
              path: "/check-index-short-index-no-reconcile-count-list/:id",
              component: () =>
                import("@/views/work/check/short/count/NoReconcileCountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 未对账",
                activeMenu: "/check-index-short-index",
              },
            },
            {
              name: "check-index-short-index-count-list",
              path: "/check-index-short-index-count-list/:id",
              component: () =>
                import("@/views/work/check/short/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 短途结账 / 统计",
                activeMenu: "/check-index-short-index",
              },
            },
          ],
        },
        /**短途结账-结束 */

        /**货代中转结账-开始*/
        {
          name: "check-index-transfer-index",
          path: "/check-index-transfer-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 货代中转结账" },

          children: [
            {
              name: "check-index-transfer-index-transfer-tips",
              path: "/check-index-transfer-index/:id",
              component: () =>
                import("@/views/work/check/transfer/TransferTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 概况",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-shortcut-check-prepare-list",
              path: "/check-index-transfer-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/transfer/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 快捷结账",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-shortcut-check-update-list",
              path: "/check-index-transfer-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/transfer/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 快结清单",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-bill-note-update-list",
              path: "/check-index-transfer-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/transfer/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 对账单",
                activeMenu: "/check-index-transfer-index",
              },
            },
             {
              name: "check-index-transfer-index-bill-check-prepare-list",
              path: "/check-index-transfer-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/transfer/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 对账单结账",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-bill-check-update-list",
              path: "/check-index-transfer-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/transfer/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 结账清单",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-no-reconcile-count-list",
              path: "/check-index-transfer-index-no-reconcile-count-list/:id",
              component: () =>
                import("@/views/work/check/transfer/count/NoReconcileCountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 未对账",
                activeMenu: "/check-index-transfer-index",
              },
            },
            {
              name: "check-index-transfer-index-count-list",
              path: "/check-index-transfer-index-count-list/:id",
              component: () =>
                import("@/views/work/check/transfer/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 货代中转结账 / 统计",
                activeMenu: "/check-index-transfer-index",
              },
            },
          ],
        },
        /**货代中转结账-结束 */


        /**站点到付代收-开始*/
        {
          name: "check-index-consignment-arrive-index",
          path: "/check-index-consignment-arrive-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 站点到付代收" },

          children: [
            {
              name: "check-index-consignment-arrive-index-consignment-arrive-tips",
              path: "/check-index-consignment-arrive-index/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/ConsignmentArriveTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 概况",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
            {
              name: "check-index-consignment-arrive-index-shortcut-check-prepare-list",
              path: "/check-index-consignment-arrive-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 快捷结账",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
            {
              name: "check-index-consignment-arrive-index-shortcut-check-update-list",
              path: "/check-index-consignment-arrive-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 快结清单",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
           {
              name: "check-index-consignment-arrive-index-bill-note-update-list",
              path: "/check-index-consignment-arrive-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 对账单",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
            {
              name: "check-index-consignment-arrive-index-bill-check-prepare-list",
              path: "/check-index-consignment-arrive-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 对账单结账",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
            {
              name: "check-index-consignment-arrive-index-bill-check-update-list",
              path: "/check-index-consignment-arrive-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 结账清单",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
            {
              name: "check-index-consignment-arrive-index-count-list",
              path: "/check-index-consignment-arrive-index-count-list/:id",
              component: () =>
                import("@/views/work/check/consignmentarrive/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 统计",
                activeMenu: "/check-index-consignment-arrive-index",
              },
            },
          ],
        },
        /**站点到付代收-结束 */

        /**干线到付结账-开始*/
        {
          name: "check-index-long-arrive-index",
          path: "/check-index-long-arrive-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 干线到付结账" },

          children: [
            {
              name: "check-index-long-arrive-index-long-arrive-tips",
              path: "/check-index-long-arrive-index/:id",
              component: () =>
                import("@/views/work/check/longarrive/LongArriveTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 概况",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
            {
              name: "check-index-long-arrive-index-shortcut-check-prepare-list",
              path: "/check-index-long-arrive-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 快捷结账",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
            {
              name: "check-index-long-arrive-index-shortcut-check-update-list",
              path: "/check-index-long-arrive-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 快结清单",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
           {
              name: "check-index-long-arrive-index-bill-note-update-list",
              path: "/check-index-long-arrive-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 对账单",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
            {
              name: "check-index-long-arrive-index-bill-check-prepare-list",
              path: "/check-index-long-arrive-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 对账单结账",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
            {
              name: "check-index-long-arrive-index-bill-check-update-list",
              path: "/check-index-long-arrive-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线到付结账 / 结账清单",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
            {
              name: "check-index-long-arrive-index-count-list",
              path: "/check-index-long-arrive-index-count-list/:id",
              component: () =>
                import("@/views/work/check/longarrive/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 站点到付代收 / 统计",
                activeMenu: "/check-index-long-arrive-index",
              },
            },
          ],
        },
        /**干线到付结账-结束 */
  
        /**托单其他结账-开始*/
        {
          name: "check-index-consignment-other-index",
          path: "/check-index-consignment-other-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 托单其他结账" },

          children: [
            {
              name: "check-index-consignment-other-index-consignment-other-tips",
              path: "/check-index-consignment-other-index/:id",
              component: () =>
                import("@/views/work/check/consignmentother/ConsignmentOtherTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 概况",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
            {
              name: "check-index-consignment-other-index-shortcut-check-prepare-list",
              path: "/check-index-consignment-other-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 快捷结账",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
            {
              name: "check-index-consignment-other-index-shortcut-check-update-list",
              path: "/check-index-consignment-other-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 快结清单",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
             {
              name: "check-index-consignment-other-index-bill-note-update-list",
              path: "/check-index-consignment-other-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 对账单",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
            {
              name: "check-index-consignment-other-index-bill-check-prepare-list",
              path: "/check-index-consignment-other-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 对账单结账",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
            {
              name: "check-index-consignment-other-index-bill-check-update-list",
              path: "/check-index-consignment-other-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 结账清单",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
            {
              name: "check-index-consignment-other-index-count-list",
              path: "/check-index-consignment-other-index-count-list/:id",
              component: () =>
                import("@/views/work/check/consignmentother/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 托单其他结账 / 统计",
                activeMenu: "/check-index-consignment-other-index",
              },
            },
          ],
        },
        /**托单其他结账-结束 */

        /**干线其他结账-开始*/
        {
          name: "check-index-long-other-index",
          path: "/check-index-long-other-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + "/ 结账管理 / 干线其他结账" },

          children: [
            {
              name: "check-index-long-other-index-long-other-tips",
              path: "/check-index-long-other-index/:id",
              component: () =>
                import("@/views/work/check/longother/LongOtherTips.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 概况",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-shortcut-check-prepare-list",
              path: "/check-index-long-other-index-shortcut-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/longother/shortcut/ShortcutCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 快捷结账",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-shortcut-check-update-list",
              path: "/check-index-long-other-index-shortcut-check-update-list/:id",
              component: () =>
                import("@/views/work/check/longother/shortcut/ShortcutCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 快结清单",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-bill-note-update-list",
              path: "/check-index-long-other-index-bill-note-update-list/:id",
              component: () =>
                import("@/views/work/check/longother/bill/BillNoteUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 对账单",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-bill-check-prepare-list",
              path: "/check-index-long-other-index-bill-check-prepare-list/:id",
              component: () =>
                import("@/views/work/check/longother/billcheck/BillCheckPrepareList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 对账单结账",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-bill-check-update-list",
              path: "/check-index-long-other-index-bill-check-update-list/:id",
              component: () =>
                import("@/views/work/check/longother/billcheck/BillCheckUpdateList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 结账清单",
                activeMenu: "/check-index-long-other-index",
              },
            },
            {
              name: "check-index-long-other-index-count-list",
              path: "/check-index-long-other-index-count-list/:id",
              component: () =>
                import("@/views/work/check/longother/count/CountList.vue"),
              meta: {
                title: webTitle + "/ 结账管理 / 干线其他结账 / 统计",
                activeMenu: "/check-index-long-other-index",
              },
            },
          ],
        },
        /**干线其他结账-结束 */

        /**统计报表-开始*/
         {
          name: "count-index-consignment-index-consignment-count-report-index",
          path: "/count-index-consignment-index-consignment-count-report-index/:id",
          component: () => import("@/views/work/count/consignment/ConsignmentCountReportIndex.vue"),
          meta: { title: webTitle + "/ 统计报表 / 托单统计" },
        },
         {
          name: "count-index-transfer-index-transfer-count-report-index",
          path: "/count-index-transfer-index-transfer-count-report-index/:id",
          component: () => import("@/views/work/count/transfer/TransferCountReportIndex.vue"),
          meta: { title: webTitle + "/ 统计报表 / 货代中转统计" },
        },
        {
          name: "count-index-long-index-long-count-report-list",
          path: "/count-index-long-index-long-count-report-list/:id",
          component: () => import("@/views/work/count/long/LongCountReportList.vue"),
          meta: { title: webTitle + "/ 统计报表 / 干线统计" },
        },
         {
          name: "count-index-no-reconcile-index-no-reconcile-count-report-list",
          path: "/count-index-no-reconcile-index-no-reconcile-count-report-list/:id",
          component: () => import("@/views/work/count/noreconcile/NoReconcileCountReportList.vue"),
          meta: { title: webTitle + "/ 统计报表 / 未对账统计" },
        },
        {
          name: "count-index-flow-index-flow-count-report-list",
          path: "/count-index-flow-index-flow-count-report-list/:id",
          component: () => import("@/views/work/count/flow/FlowCountReportList.vue"),
          meta: { title: webTitle + "/ 统计报表 / 流水统计" },
        },
        {
          name: "count-index-profit-index-profit-count-report-info",
          path: "/count-index-profit-index-profit-count-report-info/:id",
          component: () => import("@/views/work/count/profit/ProfitCountReportInfo.vue"),
          meta: { title: webTitle + "/ 统计报表 / 利润统计" },
        },
        {
          name: "count-index-log-change-index-log-change-count-report-list",
          path: "/count-index-log-change-index-log-change-count-report-list/:id",
          component: () => import("@/views/work/count/logchange/LogChangeCountReportList.vue"),
          meta: { title: webTitle + "/ 统计报表 / 操作日志" },
        },
        /**统计报表-结束 */
           
      ],
    },

    
  ],
});

/**路由守卫*/
router.beforeEach((to, from) => {
  //return;

  if (storage.getItem("session", "basic", "token") != undefined) {
    //const user: UserInfo = JSON.parse(new Tool().FormatToken(localStorage["token"]))
    //const expDate = toolObj.FormatDate(user.exp)
    if (to.path === "/login") {
      // if (expDate >= currDate) {
      //     return { path: "/desktop" }
      // } else {
      //     toolObj.ClearLocalStorage()
      // }
    } else {
      // if (expDate < currDate) {
      //     toolObj.ClearLocalStorage()
      //     return { path: "/login" }
      // }
    }
  } else {

    /**如果是协同登录直接返回*/
    if (to.path.includes("/collaborate-login/")) {
      return;
    }
    
    /**避免无限重定向，因此要做个判断*/
    if (to.path !== "/login") {
      return { path: "/login" };
    }
  }
});

/**
 * 路由守卫，如果不是系统链接，返回到登录界面
 * 加上权限控制（考虑是否加权限）
 */
router.afterEach((to, from) => {
  /**把栏目名称赋值给页面title*/
  window.document.title = to.meta.title as any;


  if (to.path.includes("/collaborate-login/")) {
    return;
  }
  //return;

  /**
  let userId=''
  try
  {
      userId= storage.getItem('session', 'basic', 'userid')
      if(!isNull(userId))
      {
          //router.replace({ path: '/login' })
      }
      else {
          //避免无限重定向，因此要做个判断
          if (to.path !== "/login") {
              return { path: "/login" }
          }
      }
      console.log('用户id',userId)
  }
  catch(e)
  {
      router.replace({ path: '/login' })
  }
 */

  if (from.path === "/") {
    /**页面刷新不跳转*/
    if (window.performance.navigation.type == 1) {
      /**console.log("页面被刷新")*/
    } else {
      router.replace({ path: "/login" });
    }
  } else {
    /**如果没有权限，跳转到login*/
  }
});

export default router;
